module.exports = __webpack_public_path__ + "img/sumUploadAct.574c0b7c.png";